var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderbordActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 168.04,
    fill: "url(#pattern0_296_29)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_296_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.665 79.8333V46.5H68.332V71.5H43.332V121.5H126.665V79.8333H101.665ZM76.6654 54.8333H93.332V113.167H76.6654V54.8333ZM51.6654 79.8333H68.332V113.167H51.6654V79.8333ZM118.332 113.167H101.665V88.1667H118.332V113.167Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_296_29",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_296_29",
    transform: "scale(0.00568182 0.00571429)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_296_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(35 34)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_296_29",
    width: 176,
    height: 175,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAACvCAMAAABq6aQiAAAAAXNSR0IB2cksfwAAAMxQTFRFAAAA/////9Va/f39+vr6ysrK9vb2t7e3tLS0/v7+5+fn7+/vu7u709PT3t7e/Pz8wsLCsrKys7Oz8vLyv7+/2NjYxMTE4ODgtbW17e3turq60dHR/////////v7+/////////////f39/////v7+////5ubm/////f39////////////////////////////9/f3/v7+////////////3Nzc////z8/P6+vrwcHB4+Pj/////////////////////////////v7+////b9XQwgAAAER0Uk5TAP///////////////////////////////////zI7QTbj7jRGOPr/5j1D+PHq3T7Z/0ng89b/9f/////DSwRtni8Kc6M8Hnl0AAAD8klEQVR4nO3dW1MaQRAF4GFBAxpCwJjECKh4v+INNd4v//8/ubukUirbzQz0mR6r5jzuQO1X1LDFA3PaGOc8Pd+URHJzf+d+d/e0+zLcLOePHryHct5U3PbhTaRSw4tFvbm4DxW3T0W9SVLGiturwl6wuCfvzcWHIDHECxSDvLn4FCCGefNnxaq4uLcN8w7FPVnvCtILEIO94mK4Nxdvr4h5D+BeUbEXb5KUpMS0t1X9/eXPj58zy4u/tq7mZ4+PK5YhxQcC4o01K+/CbKXSKNsGKLbzLqXeRrlm/8OdFK9tBOmFiWFekBjohYg7+0AvI97vBOkVF8O9wuLOGdzLiM+cxV68jPjCUdy58OJlxHs7Lt6dPU9eIbFHr4jYyjsn5GXEm0eW3k2v3qnFR769nLgbpJcRN8aKVbxTiLs6XkZcY8XdhpKXEZcYsaKXE++S3pqidwJxl3yTF6+zWN3LiddHvbv6XidxEF4HcSBeTnzy1rseitdSHJDXShyU10IcmJcT3wbpHSPuheflxB3zEKCXEb+YPrGq6iVM6fVTQyxm3q963mJUdp0Aq3sLVTT4vfdYw1vEIsHv96+St8BFgVutILyjMALcbFVz76W2d0RWDG42sw38N/NuKXs/0gjw8AO+rA+ur7S9luD8A17OvCrPswnA2Q7ONrC61xKc74jFfEMoe63B6VducL20UGkoe+3A1eEW3kp3RFnZ6wCuD+bmPxH4+0z9WwRPkghGJ4LRiWB0IhidCEYngtGJYHQiGJ0IRieC0YlgdCIYnQhGJ4LRiWB0IhidCEYngtGJYHQiGB0bcBLBUySC0YlgdCLYq5f872Uw4I8wCpwEAh5xkeAkCPAoiwYnAYALVAw4UQcXoXIwVVuoDC40pdf75oVYTFTBxaR04cF0yGVFMOkt9Yy5JV+gBqa9+blFWqwEHuM15oR8kQp4rJcTB3HeZMQblNjKy50CDODMVOHp8UDE1t5AxA7eIMS0t7Bjgj49rn52lejEUBaTXrp1RFU8gZfrmNA74c730NCtI1odAuO6ieheF52WhvFdSipi2mvRVkV3E/lvGpm2Xct3l4ttf5lnMemVaIjz2Uck08Hnr/FJquXQV6eWXI+kn9YyVy/X1OmjF869WdSLWNTLtc2iuw3l+3yx7ZGTermGZ2Q/5+ReqJj0olq/UR2zuF51TIvvtF5uMgCiJ3l6L0RMe2WmL+CncfzzSsxe8CYW9HoRi3qhM4b+e+UmtHgQi3vBYoAXMjntjVd6jlMulp5NB/aKT/+De0FioHc4cfMzeQHiEmY2HUwM96bic0FxCTdf8b1YLnivMY+CYh9eY+7upaYJPz+53/0ViA0KDRH1ox4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderbordActive);
export default __webpack_public_path__ + "static/media/leaderbord-active.20017f54a01c1a972d19628851eee804.svg";
export { ForwardRef as ReactComponent };